import _noop from "lodash/noop";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import BaseFoundation from '../base/foundation';

class TabsFoundation extends BaseFoundation {
  constructor(adapter) {
    super(_Object$assign({}, adapter));
    this.destroy = _noop;
  }

  init() {
    this._adapter.collectPane();
  }

  _notifyChange(activeKey) {
    const {
      activeKey: stateActiveKey
    } = this.getStates();

    if (stateActiveKey !== activeKey) {
      this._adapter.notifyChange(activeKey);
    }
  }

  handleTabClick(activeKey, event) {
    const isControlledComponent = this._isInProps('activeKey');

    if (isControlledComponent) {
      this._notifyChange(activeKey);
    } else {
      this._notifyChange(activeKey);

      this.handleNewActiveKey(activeKey);
    }

    this._adapter.notifyTabClick(activeKey, event);
  }

  handleNewActiveKey(activeKey) {
    const {
      activeKey: stateActiveKey
    } = this.getStates();

    if (stateActiveKey !== activeKey) {
      this._adapter.setNewActiveKey(activeKey);
    }
  }

  getDefaultActiveKey() {
    let activeKey;
    const props = this.getProps();

    if ('activeKey' in props) {
      activeKey = props.activeKey;
    } else if ('defaultActiveKey' in props) {
      activeKey = props.defaultActiveKey;
    } else {
      activeKey = this._adapter.getDefaultActiveKeyFromChildren();
    }

    return activeKey;
  }

  handleTabListChange() {
    this._adapter.collectPane();
  }

  handleTabPanesChange() {
    this._adapter.collectPane();

    this._adapter.collectActiveKey();
  }

  handleTabDelete(tabKey) {
    this._adapter.notifyTabDelete(tabKey);
  }

}

export default TabsFoundation;